import React from "react";
import quantImage from "../../assets/quantitative performance score.png";
import "./Methodology.css";

const Methodology: React.FC = () => {
  return (
    <div className="center-container">
      <img src={quantImage} alt="Logo" className="q-logo" style={{ width: 1400, height: "250" }} />
    </div>
  );
};

export default Methodology;
